module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/whatsapp-f5d1a082c77d4eddbb6ef7f7bfc04f94.png";